export default "__VITE_ASSET__DNAqwb33__"